import React from 'react'
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Header, Modal, Grid, Divider, List, Image } from 'semantic-ui-react'
import Labels from '../../../../common/Labels'
import ImageAvater from '../../../../drive/Components/ImageAvater';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import defaultLogo from "../../../../../images/logo/logo-128.png"
import TextEditor from '../../../../common/TextEditor';

class GrantPublicAccessModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            reason: ''
        };
    }

    handleClose = () => {
        this.setState({ reason: '' });
        this.props.handleGrantAccessModal(false);
    }

    async grantPublicAccess(formData) {
        let payload = {
            accountId: this.props.account._id,
            publicAccess: true,
            reason: this.state.reason
        }
        dispatch.account.updatePublicAccess(payload)
        this.handleClose()
    }

    updateText = (data, name) => {
        if (name === "Reason") {
            if (data.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
                this.setState({ reason: '' })
            } else {
                this.setState({ reason: data })
            }
        }
    }

    render() {
        let account = this.props.account;

        return (
            <Modal
                open={this.props.grantPublicAccessModalOpen}
                onClose={this.handleClose}
                size='tiny'
                className="basicModal"
                closeOnEscape={true}
                closeOnDimmerClick={false}
                closeIcon
            >
                <Header style={{ margin: '0px 0px 10px 0' }} content={"Grant Public Accesss"} ></Header>
                <Form noValidate
                    ref={ref => this.form = ref}
                    id="grantPublicAccess"
                    preventExternalInvalidation={true}
                    onValidSubmit={(event) => { this.grantPublicAccess(event) }}
                    className="formcyForm"
                >
                    <Modal.Content>
                        <Grid>
                            <Grid.Row className=' bg-clr-lightBlue' style={{ margin: "0 15px", paddingBottom: '0px' }}>
                                <Grid.Column width={8}>
                                    <Labels
                                        text={<div >
                                            <div className="accountLogoTiny" >
                                                <Image className="mar_0" src={account && account.logo ? account.logo : defaultLogo} />
                                            </div>
                                            <div className='float-left mar_5' >
                                                <EllipsisTooltip style={{ color: '#333' }} name={account && account.name} />
                                            </div>
                                        </div>}
                                    />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Labels
                                        text={<List horizontal >
                                            <List.Item>
                                                <ImageAvater user={account && account.ownerId} imageStyle="f_10 w_32 h_32 mar_0" />
                                                <div className="float-left f_12 pad_2 " >
                                                    <EllipsisTooltip
                                                        name={account && account.ownerId.firstName + ' ' + account.ownerId.lastName}
                                                        line={2}
                                                        style={{ 'lineHeight': '14px', padding: '0px 0px 2px 0px', color: '#333' }}
                                                    />
                                                    <span className="float-left f_10 pad_2 clr-dark-gray "><EllipsisTooltip
                                                        name={account && account.ownerId.email}
                                                        line={2}
                                                        style={{ 'lineHeight': '14px', color: '#333' }}
                                                    /></span>
                                                </div>
                                            </List.Item>
                                        </List>}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Divider style={{ margin: '5px 0' }} />
                            <Grid.Row className="pad_0">
                                <Grid.Column width={16}>
                                    <br />
                                    <TextEditor
                                        name="Reason"
                                        text={this.state.reason}
                                        type="textarea"
                                        onChangeText={this.updateText}
                                        requiredValue={true}
                                    />

                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row className="pad_5">
                                <Grid.Column width={16}>
                                    Are you sure you want to grant Public publishing access to this account?
								</Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                    <Divider />
                    <Modal.Actions className="actionInFormcy">

                        <Button className="button-submit float-right" formNoValidate={true} id='deactivateBtn' disabled={this.state.reason.length === 0} type="submit"> Grant </Button>
                        <Button id='cancelBtn' className="button-cancel" onClick={this.handleClose} type="button"> Cancel </Button>
                    </Modal.Actions>
                </Form>
            </Modal>
        )
    }
}

export default GrantPublicAccessModal